<body class="login_page_main_sec" *ngIf="showdiv">
    <div>
        <div class="loginparent">

            <div class="loginbox wow zoomIn" data-wow-duration="2s" data-wow-delay="0.25s">
                <div class="firstdiv">
                    <img src="/assets/img/login/Cognix_Workflow_LoginScreen.png" alt="PI Ideas Workflow">

                    <div class="cognix-login-part gifimg wow  animated" data-wow-duration="5s" data-wow-delay="1s">
                        <div class="main_frame">
                            <div class="files file1">
                                <img src="/assets/img/login/fileBlank.png" alt="File" class="" />
                                <img src="/assets/img/login/data.png" alt="Login" class="" />
                            </div>
                            <div class="files file2">
                                <img src="/assets/img/login/fileBlank.png" alt="File" class="fileback" />
                                <img src="/assets/img/login/data.png" alt="Login" class="fileData" />
                            </div>
                            <div class="files file3">
                                <img src="/assets/img/login/fileBlank.png" alt="File" class="" />
                                <img src="/assets/img/login/data.png" alt="Login" class="" />
                            </div>
                            <div class="files defaultFile">
                                <img src="/assets/img/login/fileBlank.png" alt="File" class="defaBack" />
                            </div>
                            <div class="files file4">
                                <img src="/assets/img/login/fileBlank.png" alt="File" class="" />
                                <img src="/assets/img/login/data.png" alt="Login" class="" />
                            </div>
                            <div class="files file5">
                                <img src="/assets/img/login/fileBlank.png" alt="File" class="" />
                                <img src="/assets/img/login/data.png" alt="Login" class="" />
                            </div>
                            <div class="files file6">
                                <img src="/assets/img/login/fileBlank.png" alt="File" class="" />
                                <img src="/assets/img/login/data.png" alt="Login" class="" />
                            </div>
                            <div class="files secFile">
                                <img src="/assets/img/login/fileBlank.png" alt="File" class="" />
                                <img src="/assets/img/login/data.png" alt="Login" class="" />
                            </div>

                            <img src="/assets/img/login/scan-outline.png" alt="Scan" class="scanningBox" />

                            <img src="/assets/img/login/scan.png" alt="Scan" class="scanning" />

                            <div class="gearBox">
                                <img src="/assets/img/login/gear.png" alt="Login" class="gear1" />
                                <img src="/assets/img/login/gear.png" alt="Login" class="gear2" />
                                <img src="/assets/img/login/gear.png" alt="Login" class="gear3" />
                            </div>
                        </div>
                    </div>
                    <!-- <p class="cognix-login-part firstrowtext wow zoomIn" data-wow-duration="5s" data-wow-delay="5s">
                        Solution to track and manage your Invoices</p> -->
                    <div class="cognix-login-part carousel carousel-slider statusdiv">
                        <div class="carousel-item active">
                            <p class="wow slideInRight">
                                Create and Enter invoices Manually or using Email
                            </p>
                        </div>
                        <div class="carousel-item">
                            <p>Index invoices using OCR auto extraction</p>
                        </div>
                        <div class="carousel-item">
                            <p>Configurable workflow</p>
                        </div>
                        <div class="carousel-item">
                            <p>Track invoices</p>
                        </div>
                        <div class="carousel-item">
                            <p>Set up proxy and delegation for users</p>
                        </div>
                        <div class="carousel-item">
                            <p>Customizable ERP connections</p>
                        </div>
                        <div class="carousel-item">
                            <p>Email Notifications, Reminders and Escalations</p>
                        </div>
                        <div class="carousel-item">
                            <p>Powerful reports to provide insights into the business operations</p>
                        </div>
                    </div>
                </div>

                <div class="loginhtml">
                    <!-- <img src="/assets/img/login/loginEM_AP.png" class="loginimg cognix-login-part" alt="AP Workflow"> -->
                    <!-- <img src="#" [style.hight.%]="100"  [style.width.%]="100" class="loginimg cognix-login-part" alt="PI Ideas Workflow">  -->
                    <div class="loginimg cognix-login-part">
                        <!-- <img class="bbcImg" src="../../assets/images/bbc.png" alt=""/> -->
                        <h1>
                            Welcome !
                        </h1>
                        <p>Sign in to Continue</p>
                    </div>

                    <div class="row mb_0">
                        <form *ngIf="!isAzureFlag" [formGroup]="frmLogin" (ngSubmit)="onSubmitClick()">
                            <mat-form-field [style.width.%]="100">
                                <input matInput placeholder="Enter User ID" formControlName="username">
                            </mat-form-field>
                            <mat-form-field [style.width.%]="100">
                              <input matInput placeholder="Enter Password" formControlName="securecode"
                                     [type]="inputType" autocomplete="off"
                                     [class.invalid]="frmLogin.get('securecode').invalid && (frmLogin.get('securecode').dirty || frmLogin.get('securecode').touched)">
                            </mat-form-field>
                            <input type="submit" value="SIGN IN" [disabled]="frmLogin.invalid"
                                class="btn primary_btn button openmodal">
                        </form>
                        <p *ngIf="isAzureFlag" (click)="onAzureLogin()" style="text-decoration: none;">
                            <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="300px" height="50px"
                                viewBox="0 0 3278 522" class="SignInButton">
                                <style type="text/css">
                                    .fil0:hover {
                                        fill: #4B4B4B;
                                    }

                                    .fnt0 {
                                        font-size: 260px;
                                        font-family: 'Segoe UI Semibold', 'Segoe UI';
                                        text-decoration: none;
                                    }
                                </style>
                                <rect class="fil0" x="2" y="2" width="3174" height="517" fill="black" />
                                <rect x="150" y="129" width="122" height="122" fill="#F35325" />
                                <rect x="284" y="129" width="122" height="122" fill="#81BC06" />
                                <rect x="150" y="263" width="122" height="122" fill="#05A6F0" />
                                <rect x="284" y="263" width="122" height="122" fill="#FFBA08" />
                                <text x="470" y="357" fill="white" class="fnt0">Sign in using AzureAD</text>
                            </svg>
                        </p>
                    </div>
                </div>

            </div>
        </div>

        <div class="footertext cognix-login-part" id="globalFooter">
            <div>
                Copyright © 2026 Tata Consultancy Services&nbsp;|&nbsp;Release V1.0&nbsp;|
                <a href ="https://www.tcs.com/who-we-are/legal/tcs-privacy-notice" target="_blank" rel = "noopener" style="color: white">&nbsp;Privacy Notice&nbsp;</a>|
                <a [routerLink] = "['/cookie-policy']" target="_blank" rel = "noopener"
                style="color: white">&nbsp;Cookie Ploicy&nbsp;</a>|
                <p id="pbrowserCompatibility" [ngbPopover]="browserCompatibility"
                    [popoverTitle]="browserCompatibilityTitle">
                    &nbsp;Browser Compatibility</p>
            </div>
        </div>
    </div>

    <ng-template #browserCompatibilityTitle id="popComTitle">
        <div>
            <div id="browserCompatibilityTitle"> Browser Compatibility</div>
        </div>
    </ng-template>
    <ng-template #browserCompatibility id="popComcontent">
        <ul>
            <li>Internet explorer 11</li>
            <li>Google chrome 58</li>
            <li>Mozila Firefox 54</li>
        </ul>
        <p class="browserCompatibilitypara">This site is best viewed in 1366X768 resolution.</p>
    </ng-template>

    <ng-template #privacyModal let-modal>
        <div class="modal-content">
            <div class="modal-header model_center_header">
                <h4 class="modal-title">Privacy Policy</h4>
                <button type="button" class="close model_close_btn" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true" class="model_close_btn">×</span>
                </button>
            </div>
            <div class="modal-body custom_modal_body">
                <div class="model_content">
                    <div [innerHtml]="userAcceptancePrivacyPolicyContent"></div>
                </div>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" class="btncss btn_secondary mt-0"
                    (click)="modal.close('Save click')">Cancel</button>
                <button type="button" class="btncss btn_primary mt-0" (click)="modal.close('Save click')">Ok</button>
            </div>
        </div>
    </ng-template>

    <ng-template #userAcceptancePrivacyPolicyModal let-modal>
        <div class="modal-content">
            <div class="modal-header model_center_header">
                <h5 class="modal-title">Privacy Policy</h5>
                <button type="button" class="close model_close_btn" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true" class="model_close_btn">×</span>
                </button>
            </div>
            <div class="modal-body custom_modal_body">
                <div class="model_content">
                    <div [innerHtml]="userAcceptancePrivacyPolicyContent"></div>
                </div>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" class="btncss btn_primary mt-0" (click)="acceptPrivacyPolicy()">Accept</button>
            </div>
        </div>
    </ng-template>
    <div class="modal fade" #privacyModalref id="privacyPolicyModal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header model_center_header">
                    <h5 class="modal-title">PRIVACY NOTICE POLICY</h5>
                    <button type="button" class="close model_close_btn" data-bs-dismiss="modal">
                        <span aria-hidden="true" class="model_close_btn">×</span>
                    </button>
                </div>

            </div>
        </div>
    </div>
</body>
